import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import MuscleBackendManager from "@lib/data/templates/backend-manager.class";
import { formatDateToISOWithoutTimezone } from "@lib/util/date-ops";
class FlightsManager extends MuscleBackendManager {
  constructor() {
    var _process$env$NEXT_PUB;
    super(((_process$env$NEXT_PUB = process.env.NEXT_PUBLIC_MUSCLE_FLIGHTS_API_BASE_URL) !== null && _process$env$NEXT_PUB !== void 0 ? _process$env$NEXT_PUB : "http://localhost:3002/flight/api/v1") + "/flights/");
    this.controller = void 0;
    this.controller = new AbortController();
  }
  async getBaggageByBookingId(bookingId) {
    const response = await super.getAxiosInstance().get("/reservations/".concat(encodeURIComponent(bookingId), "/baggage"));
    return response.data;
  }
  async getFlightReservations() {
    const response = await super.getAxiosInstance().get('/reservations', {
      params: {
        // Temporary, check pagination
        page_size: 999
      }
    });
    return response.data;
  }
  async priceBaggage(searchQueryId, items, bookingId) {
    const response = await super.getAxiosInstance().post("/reservations/".concat(encodeURIComponent(bookingId), "/baggage/price-selection"), {
      search_query_id: searchQueryId,
      items: items
    });
    return response.data;
  }
  async payBaggage(searchQueryId, bookingId, log_info, payment_information) {
    const response = await super.getAxiosInstance().post("/reservations/".concat(encodeURIComponent(bookingId), "/baggage/pay"), {
      search_query_id: searchQueryId,
      log_info: log_info,
      payment_information: payment_information
    });
    return response.data;
  }
  async getFlightReservationByBookingId(bookingId) {
    const response = await super.getAxiosInstance().get("/reservations/".concat(encodeURIComponent(bookingId)));
    return response.data;
  }
  async getPassengerRequirements(searchQueryId) {
    const response = await super.getAxiosInstance().get("/passenger-requirements", {
      params: {
        search_query_id: encodeURIComponent(searchQueryId)
      }
    });
    return response.data;
  }
  async getFlightsParams(search_params, selecting_itinerary_index, flights_selection, selected_fares, search_query_id, filters, sort_by, page_number, page_size) {
    var _search_params$flight, _search_params$flight2;
    const search_data = {
      search_params: search_params,
      selecting_itinerary_index,
      selected_fares: selected_fares,
      search_query_id,
      flights_selection,
      filters,
      sort_by,
      page_number,
      page_size
    };

    // Change dates to ISO string without mutating the original search_params
    const clonedSearchParams = _objectSpread(_objectSpread({}, search_params), {}, {
      flight_info: (_search_params$flight = (_search_params$flight2 = search_params.flight_info) === null || _search_params$flight2 === void 0 ? void 0 : _search_params$flight2.map(flight => _objectSpread(_objectSpread({}, flight), {}, {
        departure_date: flight.departure_date ? formatDateToISOWithoutTimezone(flight.departure_date) : undefined,
        return_date: flight.return_date ? formatDateToISOWithoutTimezone(flight.return_date) : undefined
      }))) !== null && _search_params$flight !== void 0 ? _search_params$flight : []
    });
    search_data.search_params = clonedSearchParams;
    const response = await super.getAxiosInstance().post('/search', search_data);
    return response.data;
  }
  async getFlightsContextBySearchQueryId(search_query_id) {
    const response = await super.getAxiosInstance().get("/get-current-search-cache-data?search_query_id=".concat(encodeURIComponent(search_query_id)));
    return response.data;
  }
  async getFlightsSelectionPricing(flight_type, passengers_details, selected_flights, selected_fare_families, seat_information, baggage_information, search_query_id) {
    const fares = process.env.NEXT_PUBLIC_FLIGHTS_ALLOW_FARE_FAMILIES_SELECTION === "true" ? selected_fare_families : [];
    const request = {
      flight_type,
      passengers_details,
      selected_flights,
      selected_fare_families: fares,
      seat_information: seat_information,
      baggage_information: baggage_information,
      search_query_id
    };
    const response = await super.getAxiosInstance().post("/price-selection", request);
    return response.data;
  }
  async getServiceList(flight_type, passengers_details, selected_flights) {
    const request = {
      flight_type,
      passengers_details,
      selected_flights,
      selected_fare_families: []
    };
    const response = await super.getAxiosInstance().post("/service-list", request);
    return response.data;
  }
  async getSeatAvailability(flight_type, passengers_details, selected_flights) {
    const request = {
      flight_type,
      passengers_details,
      selected_flights,
      selected_fare_families: []
    };
    const response = await super.getAxiosInstance().post("/seat-availability", request);
    return response.data;
  }
  async getFlightFares(flight, search, index, path, selectedFares, passengers_details, flight_type, search_query_id) {
    const search_data = {
      search_params: search,
      flight,
      index: index,
      path: path,
      fares: selectedFares,
      passengers_details: passengers_details,
      flight_type: flight_type,
      search_query_id: search_query_id
    };
    const response = await super.getAxiosInstance().post("/flight-fares", search_data);
    return response.data;
  }
  async payOrder(flight_type, passengers_details, selected_flights, passenger_information, log_info, payment_information, search_query_id, selected_fare_families) {
    const request = {
      flight_type,
      passengers_details,
      selected_flights,
      passenger_information,
      payment_information,
      log_info: log_info,
      search_query_id: search_query_id,
      selected_fare_families: selected_fare_families
    };
    const response = await super.getAxiosInstance().post("/pay-order", request, {
      // 6 minutes timeout
      timeout: 360000
    });
    return response.data;
  }
  async resumePayOrder(search_query_id, new_payment_info) {
    const request = {
      search_query_id: search_query_id,
      new_payment_info
    };
    const response = await super.getAxiosInstance().post("/pay-order/resume", request, {
      // 6 minutes timeout
      timeout: 360000
    });
    return response.data;
  }
  async cancelOrder(search_query_id) {
    const request = {
      search_query_id: search_query_id
    };
    const response = await super.getAxiosInstance().post("/pay-order/cancel", request, {
      // 6 minutes timeout
      timeout: 360000
    });
    return response.data;
  }
  async resendEmail(orderNumber, email) {
    const request = {
      order_number: orderNumber,
      email: email
    };
    const response = await super.getAxiosInstance().post("/resend-email", request);
    return response.data;
  }
  async getFlightCalendarInfo(search_params) {
    const response = await super.getAxiosInstance().post("/search-calendar", search_params);
    return response.data;
  }
  async getMonthlyFlightCalendar(search_params) {
    this.controller.abort();
    this.controller = new AbortController();
    const response = await super.getAxiosInstance().post("/price-monthly-calendar", search_params, {
      signal: this.controller.signal
    });
    return response.data;
  }
  async resumePayBaggage(bookingId, searchQueryId) {
    const response = await super.getAxiosInstance().post("/reservations/".concat(encodeURIComponent(bookingId), "/baggage/pay/resume"), {
      search_query_id: searchQueryId
    }, {
      // 6 minutes timeout
      timeout: 360000
    });
    return response.data;
  }
  async cancelBaggageOrder(bookingId, searchQueryId) {
    const response = await super.getAxiosInstance().post("/reservations/".concat(encodeURIComponent(bookingId), "/baggage/pay/cancel"), {
      search_query_id: searchQueryId
    }, {
      // 6 minutes timeout
      timeout: 360000
    });
    return response.data;
  }
}
const flightsManager = new FlightsManager();
export default flightsManager;